import * as React from 'react';
import {observer} from 'mobx-react';
import {classes, style} from 'typestyle';
import {SVGIcon} from './svg-icon';
import {centerCenter, vertical, verticallySpaced} from 'csstips';
import {colorBackgroundAlt, colorBrand} from '../theme/color';
import {px} from 'csx';
import {transitionQuickEase} from '../theme/transition';
import {CreditCard} from './credit-card';

export interface CreditCardAddModel {
}

export interface CreditCardAddProps {
  className?: string;
  selected?: boolean;
  model?: CreditCardAddModel;
  onAddCard(): void;
  i18n?: {
    add: string;
  }
}

const DEFAULT_I18N = {
  add: 'Add payment method'
};

export const CreditCardAdd = observer<CreditCardAddProps>(
  ({ className, selected, i18n = DEFAULT_I18N, onAddCard }) => (
    <div className={classes(className, CreditCard.styles.container, selected && styles.innerSelected)}>
      <div className={styles.inner} onClick={onAddCard}>
        <SVGIcon.Cross size={50} color={colorBrand.toString()} />
        <span>{i18n.add}</span>
      </div>
    </div>
  )
);

const styles = {
  inner: style({
    ...vertical,
    ...verticallySpaced(30),
    ...centerCenter,
    zIndex: 2,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: colorBackgroundAlt.toString(),
    transition: `all ${transitionQuickEase}`,
    border: `2px solid ${colorBackgroundAlt.toString()}`,
    cursor: 'pointer',
    fontWeight: 200,
    $nest: {
      '&:hover': {
        background: colorBackgroundAlt.darken(0.15).toString(),
        borderColor: colorBackgroundAlt.darken(0.15).toString(),
      },
      '&> svg': {
        transform: 'rotate(45deg)'
      },
      '&> svg > g': {
        strokeWidth: px(1)
      }
    }
  }),
  innerSelected: style({
    borderWidth: px(2),
    borderColor: colorBrand.toString(),
    $nest: {
      '&:hover': {
        borderColor: colorBrand.toString(),
      }
    }
  })
};